<template>
  <div v-if="trending.length" class="community-trending-posts">
    <h6 class="trending-title">Publicações em alta</h6>

    <button
      v-for="post in trending"
      :key="post.id"
      class="trending-item d-flex align-items-center"
      @click="$emit('select', post)"
    >
      <div class="trending-avatar">
        <img v-if="authorPhoto(post)" :src="authorPhoto(post)" alt="" />
        <span v-else class="letter">{{ authorInitial(post) }}</span>
      </div>
      <div class="trending-info flex-fill">
        <span class="trending-excerpt">{{ excerpt(post) }}</span>
        <small class="trending-author">{{ authorName(post) }}</small>
      </div>
    </button>
  </div>
</template>

<script>
const MAX_ITEMS = 3;

export default {
  name: "TrendingPosts",
  props: {
    posts: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    trending() {
      return [...this.posts]
        .filter(post => this.engagement(post) > 0)
        .sort((a, b) => this.engagement(b) - this.engagement(a))
        .slice(0, MAX_ITEMS);
    }
  },
  methods: {
    engagement(post) {
      return (post.likes_count || 0) + (post.comments_count || 0);
    },
    authorName(post) {
      return (post.author && post.author.name) || "Usuário";
    },
    authorPhoto(post) {
      return post.author && post.author.photo;
    },
    authorInitial(post) {
      return (this.authorName(post)[0] || "?").toUpperCase();
    },
    excerpt(post) {
      const doc = new DOMParser().parseFromString(post.text || "", "text/html");
      const text = (doc.body.textContent || "").trim();
      if (text) return text;
      return post.image ? "Publicação com imagem" : "Publicação";
    }
  }
};
</script>

<style lang="scss" scoped>
.community-trending-posts {
  padding: 16px;
  border-radius: 4px;
  border: 1px solid rgba(128, 128, 128, 0.2);
  background: rgba(128, 128, 128, 0.06);
  font-family: "Inter", "Noto Sans", sans-serif;

  .trending-title {
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    margin-bottom: 16px;
  }

  .trending-item {
    width: 100%;
    border: none;
    background: transparent;
    padding: 0;
    margin-bottom: 16px;
    color: inherit;
    text-align: left;
    gap: 8px;
    align-items: flex-start;

    &:last-child {
      margin-bottom: 8px;
    }

    .trending-avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(128, 128, 128, 0.2);
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .letter {
        font-size: 12px;
        font-weight: 500;
      }
    }

    .trending-info {
      min-width: 0;
      display: flex;
      flex-direction: column;

      .trending-excerpt {
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .trending-author {
        font-size: 12px;
        line-height: 16px;
        opacity: 0.7;
      }
    }

    &:hover .trending-excerpt {
      text-decoration: underline;
    }
  }

  .theme-dark & {
    background: #0d161c;
    border-color: #07151f;

    .trending-title {
      color: #ffffff;
    }

    .trending-item {
      .trending-avatar {
        background: #54acbe;
        border: 1px solid #438a98;

        .letter {
          color: #2c3942;
        }
      }

      .trending-excerpt {
        color: #fdfdfd;
      }

      .trending-author {
        color: #787878;
        opacity: 1;
      }
    }
  }
}
</style>
